import { ReactSVG } from 'react-svg';
import { media, styled } from '@styles';
import { css } from 'styled-components';

const AttributeField = styled.div`
  display: flex;
  input[type='radio'] {
    display: none;
    position: relative;
    right: -999em;
  }
  label {
    cursor: pointer;
    margin-top: 10px;
    ${media.largeScreen`
      margin-top: 0;
    `}
    &:not(:last-child) {
      margin-right: 6px;
    }
  }
`;

export const Configurator = styled(AttributeField)`
  margin-top: 30px;
  flex-direction: column;
  ${media.largeScreen`
    margin-top: 30px;
  `}
  ${media.smallScreen`
    margin-top: 10px;
  `}
  ${media.smallestScreen`
    margin-top: 10px;
  `}
  label {
    transition: ${({ theme: { button } }) => button.animation.transition};
    color: #839098;
    > div {
      border-radius: 50%;
      width: 56px;
      height: 56px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: capitalize;
      background-color: #ffffff;
      font-size: ${(props) => props.theme.typography.labelFontSize};
      ${media.largeScreen`
        width: 36px;
        height: 36px;
      `}
      ${media.smallScreen`
        width: 24px;
        height: 24px;
      `}
    }

    &:not(:last-child) {
      position: relative;
      margin-right: 0;
      ${media.largeScreen`
        margin-bottom: 6px;
      `}
    }

    &:hover {
      box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.05);
    }
  }

  input:checked + div {
    color: ${({ theme: { colors } }) => colors.baseFont};
  }
`;

const pillStyle = css`
  div {
    img {
      width: 100%;
    }
    border-radius: 6px;
    border: 1px solid #faf8f8;
    background-color: #faf8f8;
    transition: ${({ theme: { button } }) => button.animation.transition};
    display: flex;
    justify-content: center;
    align-items: center;
    text-transform: capitalize;
    overflow: hidden;
    span,
    & + span {
      transition: opacity 0.3s;
      opacity: 0.5;
      line-height: 16px;
      font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
      font-size: ${(props) => props.theme.typography.labelFontSize};
      font-weight: 500;
      user-select: none;
      text-transform: capitalize;
      ${media.largeScreen`
        line-height: 13px;
      `}
      ${media.smMediumScreen`
        line-height: 16px;
      `}
    }

    &:hover {
      border-color: ${({ theme: { colors } }) => colors.red};
    }
  }
  input:checked + div {
    background-color: #ffffff;
    border-color: ${({ theme: { colors } }) => colors.red};
    span,
    & + span {
      opacity: 1;
    }
  }
`;

export const Pill = styled(AttributeField)`
  ${pillStyle}
  label {
    > div {
      min-width: 90px;
      height: 25px;
    }
  }
`;

export const Dropdown = styled(AttributeField)`
  ${pillStyle}
  label {
    text-align: center;
    > div {
      width: 46px;
      height: 46px;
      ${media.xLargeScreen`
        width: 42px;
        height: 42px;
      `}
      ${media.largeScreen`
        width: 30px;
        height: 30px;
      `}
      ${media.smMediumScreen`
        width: 64px;
        height: 64px;
      `}
      ${media.smallScreen`
        width: 48px;
        height: 48px;
      `}
      ${media.xSmallScreen`
        width: 36px;
        height: 36px;
      `}
      > div {
        width: 46px;
        height: 46px;
        ${media.xLargeScreen`
          width: 42px;
          height: 42px;
        `}
        ${media.largeScreen`
          width: 30px;
          height: 30px;
        `}
        ${media.smMediumScreen`
          width: 64px;
          height: 64px;
        `}
        ${media.smallScreen`
          width: 48px;
          height: 48px;
        `}
        ${media.xSmallScreen`
          width: 36px;
          height: 36px;
        `}
      }
    }
    span {
      margin-top: 6px;
      display: block;
    }
  }
  label:not(:last-child) {
    margin-right: 20px;
    ${media.smMediumScreen`
      margin-right: 20px;
    `}
  }
`;

export const Track = styled(AttributeField)``;

export const PillButton = styled.button<{ active: boolean }>`
  min-width: 90px;
  height: 25px;
  // margin-top: 10px;
  border: 1px solid;
  border-radius: 6px;
  border-color: ${({ active, theme: { colors } }) =>
    active ? colors.red : '#faf8f8'};
  background-color: ${({ active }) => (active ? '#ffffff' : '#faf8f8')};
  transition: ${({ theme: { button } }) => button.animation.transition};
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  overflow: hidden;

  &:not(:last-child) {
    margin-right: 6px;
  }

  & > span {
    color: ${({ theme: { colors } }) => colors.baseFont};
    transition: opacity 0.3s;
    opacity: ${({ active }) => (active ? 1 : 0.5)};
    line-height: 16px;
    font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
    font-size: ${({ theme: { typography } }) => typography.labelFontSize};
    font-weight: 500;
    user-select: none;
    text-transform: capitalize;
    ${media.largeScreen`
      line-height: 13px;
    `}
    ${media.smMediumScreen`
      line-height: 16px;
    `}
  }
`;

export const Slider = styled(AttributeField)`
  padding: 10px 0 0;
  display: flex;
  align-items: center;
  ${media.smMediumScreen`
    height: 65px;
    width: 100%;
    margin: 10px 10px 0px 10px;
  `}
  ${media.smallScreen`
    width: 100%;
    height: auto;
    align-items: flex-start;
    margin: 10px 10px 0px 10px;
  `}
`;

export const SliderColumn = styled.div`
  width: 320px;
  position: relative;
  ${media.mediumScreen`
    width: 20vw;
  `}
  ${media.smMediumScreen`
    width: 100%;
  `}
`;

export const SliderRow = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const SliderEdgeValue = styled.div<{ active: boolean }>`
  position: absolute;
  top: -20px;
  font-family: ${({ theme: { typography } }) => typography.extraFontFamily};
  font-size: ${({ theme: { typography } }) => typography.labelFontSize};
  color: ${({ active, theme: { colors } }) =>
    active ? colors.blueLight : colors.graySemi};
  font-weight: 500;
  line-height: 160%;
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  &.max {
    right: 0px;
  }
`;

export const SliderInfoButton = styled.img`
  margin-left: 12px;
  ${media.smMediumScreen`
    margin-left: 30px;
  `}
`;

export const SquareSwatch = styled(AttributeField)`
  ${media.smMediumScreen`
    display: flex;
  `}
  display: grid;
  grid-gap: 16px;
  grid-template-columns: repeat(auto-fit, minmax(80px, max-content));
  justify-content: center;
  flex: 1;
`;

export const CircleSwatchIcon = styled(ReactSVG)``;

export const CircleSwatchItem = styled.div`
  background-position: center;
  background-size: 60px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.3s;
  border: 4px solid transparent;
  ${media.largeScreen`
    width: 18px;
    height: 18px;
  `}
  ${media.smMediumScreen`
    width: 32px;
    height: 32px;
  `}
  ${CircleSwatchIcon} {
    display: none;
  }
  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
  }
`;

export const CircleSwatch = styled(AttributeField)`
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: 0 -10px;
  ${media.smMediumScreen`
    justify-content: flex-start;
    margin: 0;
  `}
  label {
    margin: 3px 5px 3px;
    &:not(:first-child) {
      ${media.smMediumScreen`
        margin-left: 0;
      `}
    }
    ${media.smMediumScreen`
      margin-left: 0;
      margin-right: 6px;
    `}
  }

  input:checked + div {
    border-color: rgba(255, 255, 255, 0.3);
    ${CircleSwatchIcon} {
      display: block;
      div {
        display: flex;
        justify-content: center;
        align-items: center;
        svg {
          transform: scale(0.8);
          ${media.largeScreen`
            transform: scale(0.5);
          `}
        }
      }
    }
  }
`;
